import { defineMessages } from 'react-intl';

export default defineMessages({
  commentOnDiffTitle: {
    id: 'frontbucket.repository.pullRequestCommentTitle.commentOnDiffTitle',
    description:
      'text to display in the title of the comment event before the file name',
    defaultMessage: 'commented on',
  },
  commentOnOverview: {
    id: 'frontbucket.repository.pullRequestCommentTitle.commentOnOverview',
    description:
      'text to display in the title of the comment event when the comment is on the overview',
    defaultMessage: 'commented',
  },
});
